import { useMemo } from "react";
import { Table, Checkbox } from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const EventTable = ({
  filteredEvents,
  selectedGroups,
  setSelectedGroups,
  onEdit,
  currentPage,
  setCurrentPage,
  pageSize,
}) => {
  // Paginated Events with recalculated rowSpan
  const paginatedEvents = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const pageData = filteredEvents.slice(startIndex, startIndex + pageSize);

    const groupedByEvent = pageData.reduce((acc, row) => {
      if (!acc[row.eventName]) acc[row.eventName] = [];
      acc[row.eventName].push(row);
      return acc;
    }, {});

    const recalculated = [];
    Object.values(groupedByEvent).forEach((group) => {
      group.forEach((row, index) => {
        recalculated.push({
          ...row,
          rowSpan: index === 0 ? group.length : 0,
          checkedRowSpan: index === 0 ? group.length : 0,
        });
      });
    });

    return recalculated;
  }, [filteredEvents, currentPage, pageSize]);

  // Table Columns
  const columns = [
    {
      title: "Assign",
      dataIndex: "select",
      key: "select",
      render: (_, record) => ({
        children:
          record.checkedRowSpan > 0 ? (
            <Checkbox
              checked={selectedGroups.includes(record.eventName)}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedGroups((prev) =>
                  checked
                    ? [...prev, record.eventName]
                    : prev.filter((name) => name !== record.eventName)
                );
              }}
            />
          ) : null,
        props: { rowSpan: record.checkedRowSpan },
      }),
      align: "center",
    },
    {
      title: "Event Name",
      dataIndex: "eventName",
      key: "eventName",
      width: 140,
      render: (text, record) => ({
        children: <strong>{text}</strong>,
        props: { rowSpan: record.rowSpan },
      }),
    },
    { title: "Event Topic", dataIndex: "topic", key: "topic", width: 130 },
    {
      title: "Timing",
      dataIndex: "timing",
      key: "timing",
      align: "center",
      width: 130,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      align: "center",
      width: 120,
      render: (text) => (text ? dayjs(text).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      align: "center",
      width: 120,
      render: (text) => (text ? dayjs(text).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Trainer",
      dataIndex: "trainer",
      key: "trainer",
      align: "center",
      width: 130,
    },
    {
      title: "Event Access",
      dataIndex: "location_link",
      key: "location_link",
      align: "center",
      render: (text) =>
        text && text.startsWith("http") ? (
          <a href={text} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        ) : (
          text || "-"
        ),
    },
    {
      title: "Participants",
      dataIndex: "participants",
      key: "participants",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <EditOutlined
          style={{ color: "#1677ff", cursor: "pointer", fontSize: "18px" }}
          onClick={() => onEdit(record)}
        />
      ),
    },
  ];

  return (
    <Table
      bordered
      columns={columns}
      dataSource={paginatedEvents}
      pagination={{
        current: currentPage,
        pageSize,
        total: filteredEvents.length,
        onChange: (page) => setCurrentPage(page),
      }}
    />
  );
};

export default EventTable;